import React from 'react'
import {
  Flex,
  HOCSpacingKeys,
  LiteralUnion,
  SpacingDirection,
  BRUnion,
} from '@sendoutcards/quantum-design-ui'

type OrderDetailsSectionType = {
  children?: React.ReactNode
  invertBackgroundColor?: boolean
  borderRadius?: BRUnion
  outset?: SpacingDirection | LiteralUnion<HOCSpacingKeys>
  inset?: SpacingDirection | LiteralUnion<HOCSpacingKeys>
}

export const OrderDetailsSection: React.FC<OrderDetailsSectionType> = ({
  invertBackgroundColor,
  children,
  borderRadius = '40px',
  outset,
  inset,
}) => {
  return (
    <Flex
      outset={outset}
      inset={inset}
      justifyContent="center"
      alignItems="center"
      borderRadius={borderRadius}
      width="100%"
      height="fit-content"
      backgroundColor={invertBackgroundColor ? 'foreground' : '#F2F2F2'}
    >
      {children}
    </Flex>
  )
}
